<template>
  <div class="input-split-container">
    <div
      class="data-input-wrap"
      :class="{white:white}"
    >
      <slot name="input-list" />
    </div>
    <slot name="right" />
  </div>
</template>
<script>
export default {
  name: "InputSplitContainer",
  props: {
    white: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/input-split-container";
</style>